import { Country } from '@commenda/prisma';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { GetNexusReturnType } from './nexus.types';

// You can either pass corporationId or the companyId. You can't pass both at the same time
export function useGetNexus({
  corporationIds,
  country,
  nextAuthToken,
  state,
}: {
  nextAuthToken: string | undefined;
  state: string;
  country: Country;
  corporationIds: number[];
}) {
  let url = 'nexus';

  const queryParams = new URLSearchParams();

  queryParams.append('state', state);
  queryParams.append(
    'corporationIds',
    corporationIds?.map((id) => id?.toString())?.join(',')
  );
  queryParams.append('country', country);

  if (queryParams.toString() !== '') {
    url += `?${queryParams.toString()}`;
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: GetNexusReturnType;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    url,
    SWRFetcher(
      {
        method: 'GET',
      },
      nextAuthToken
    )
  );

  return {
    data,
    error,
    mutate,
  };
}
